/* eslint-disable no-unused-vars */
import { ButtonBase } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  ACTIVE_STATUS,
  COMPLETED_STATUS,
  WAITING_FOR_SHIPPING,
  WAITING_FOR_INSPECTION,
  ESCALATION_STATUS,
  CLOSED_STATUS,
  ITEM_ACCEPTED_STATUS,
  RESOLVED_STATUS,
  ACTIVE_STATUS_DESCRIPTION,
  COMPLETED_STATUS_DESCRIPTION,
  WAITING_FOR_SHIPPING_STATUS_DESCRIPTION,
  ITEM_ACCEPTED_STATUS_DESCRIPTION,
  WAITING_FOR_INSPECTION_STATUS_DESCRIPTION,
  ESCALATION_STATUS_DESCRIPTION_CUSTOMER,
  ESCALATION_STATUS_DESCRIPTION_SELLER,
  RESOLVE_BUYER_REFUND_STATUS_DESCRIPTION,
  RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION,
  CLOSED_REFUND_DESCRIPTION,
  CLOSED_RELEASE_DESCRIPTION,
  CANCELLED_STATUS_TITLE,
  CANCELLED_STATUS_DESCRIPTION,
  PENDING_APPROVAL,
  PENDING_APPROVAL_DESCRIPTION,
  WAITING_SETTLEMENT_STATUS,
  WAITING_SETTLEMENT_STATUS_DESCRIPTION,
  READY_FOR_CASHOUT_STATUS,
  READY_FOR_CASHOUT_STATUS_DESCRIPTION,
  CASHOUT_APPROVED_STATUS,
  CASHOUT_APPROVED_STATUS_DESCRIPTION,
  EXCEPTIONAL_COMPLETED_STATUS,
  EXCEPTIONAL_COMPLETED_STATUS_DESCRIPTION,
} from "../../../../components/contractListItem/constants";
import { ECONTRACT_STATUS } from "../../../../enums";
import { CONTRACT_STATUS } from "../../constants";
import { ContractSubTitle } from "../../titles";
import { IContractStatusProps } from "../models";
import styles from "./styles.module.css";
import { EContractActions } from "../../../../setup/api/services/contractActions/enum";
import {
  EContractType,
  ESenderRole,
} from "../../../../setup/api/services/contract/models";
import { useTranslation } from "react-i18next";

const Img = styled("img")({
  // display: "block",
  width: "40px",
  height: "40px",
  borderRadius: "50%",
});

const Status = (props: IContractStatusProps) => {
  const { status, actorType, escalationType, contract } = props;
  const { t } = useTranslation();
  const [img, setImg] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [backGroundColor, setBackGroundColor] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  useEffect(() => {
    setStatusItems();
  }, [status]);
  const setStates = ({ compImg, compTitle, backGround, compDesc }: any) => {
    setImg(compImg);
    setTitle(compTitle);
    setBackGroundColor(backGround);
    setDescription(compDesc);
  };
  const setStatusItems = () => {
    switch (status) {
      case ECONTRACT_STATUS.CREATED:
        setStates({
          compImg: "/assets/images/svg/active.svg",
          compTitle: ACTIVE_STATUS,
          backGround: "rgba(68, 193, 110, 0.07)",
          compDesc: ACTIVE_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.PARTIALLY_PAID: {
        const customerPartiesCount = contract?.parties?.filter(
          (p) => p.role === ESenderRole.CUSTOMER
        ).length;
        const isWaitingSinglePartyPayment =
          contract?.type !== EContractType.QUICK_TRANSACTION &&
          customerPartiesCount === 1;

        setStates(
          isWaitingSinglePartyPayment
            ? {
                compImg: "/assets/images/svg/pendingBank.svg",
                compTitle: PENDING_APPROVAL,
                backGround: "rgba(255, 195, 84, 0.06)",
                compDesc: PENDING_APPROVAL_DESCRIPTION,
              }
            : {
                compImg: "/assets/images/svg/active.svg",
                compTitle: ACTIVE_STATUS,
                backGround: "rgba(68, 193, 110, 0.07)",
                compDesc: ACTIVE_STATUS_DESCRIPTION,
              }
        );
        break;
      }

      case ECONTRACT_STATUS.SUBMITTED:
        setStates({
          compImg:
            contract?.type === EContractType?.BROKERAGE_CONTRACT
              ? "/assets/images/svg/brokerCreated.svg"
              : contract?.senderRole === ESenderRole.CUSTOMER
              ? "/assets/images/svg/waitingSettlement.svg"
              : "/assets/images/svg/active.svg",
          compTitle:
            contract?.type === EContractType?.BROKERAGE_CONTRACT
              ? t("lbl_join_parties_to_transation")
              : contract?.senderRole === ESenderRole.CUSTOMER
              ? t("lbl_waiting_for_seller_to_join")
              : ACTIVE_STATUS,
          backGround:
            contract?.type === EContractType?.BROKERAGE_CONTRACT
              ? "rgba(99, 202, 250, 0.06)"
              : contract?.senderRole === ESenderRole.CUSTOMER
              ? "rgba(209, 139, 73, 0.07)"
              : "rgba(68, 193, 110, 0.07)",
          compDesc:
            contract?.type === EContractType?.BROKERAGE_CONTRACT
              ? t("lbl_waiting_for_depositor_depositary")
              : contract?.senderRole === ESenderRole.CUSTOMER
              ? t("lbl_seller_not_joined_yet")
              : ACTIVE_STATUS_DESCRIPTION,
        });
        break;

      case ECONTRACT_STATUS.COMPLETED:
        setStates({
          compImg: "/assets/images/svg/done.svg",
          compTitle: COMPLETED_STATUS,
          backGround: styles.ContractStatus,
          compDesc: COMPLETED_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED:
        setStates({
          compImg: "/assets/images/svg/done.svg",
          compTitle: EXCEPTIONAL_COMPLETED_STATUS,
          backGround: styles.ContractStatus,
          compDesc: EXCEPTIONAL_COMPLETED_STATUS_DESCRIPTION,
        });
        break;
      // waiting for approval
      case ECONTRACT_STATUS.PENDING_APPROVAL:
        setStates({
          compImg: "/assets/images/svg/approval.svg",
          compTitle: PENDING_APPROVAL,
          backGround: "rgba(255, 195, 84, 0.06)",
          compDesc: PENDING_APPROVAL_DESCRIPTION,
        });
        break;
      // manual bank trnasfer pending
      case ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION:
        setStates({
          compImg: "/assets/images/svg/pendingBank.svg",
          compTitle: PENDING_APPROVAL,
          backGround: "rgba(255, 195, 84, 0.06)",
          compDesc: PENDING_APPROVAL_DESCRIPTION,
        });
        break;

      case ECONTRACT_STATUS.WAITING_FOR_DELIVERY:
        setStates({
          compImg: "/assets/images/svg/shipping.svg",
          compTitle: WAITING_FOR_SHIPPING,
          backGround: "rgba(83, 55, 195, 0.05)",
          compDesc: WAITING_FOR_SHIPPING_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.SHIPPED:
        setStates({
          compImg: "/assets/images/svg/shipping.svg",
          compTitle: t("global_status_shipped_title"),
          backGround: "rgba(83, 55, 195, 0.05)",
          compDesc: t("status_shipped_subtitle"),
        });
        break;
      case ECONTRACT_STATUS.ITEM_ACCEPTED:
        setStates({
          compImg:
            contract?.type === EContractType?.QUICK_TRANSACTION
              ? "/assets/images/svg/readyForCashout_status.svg"
              : "/assets/images/svg/done.svg",
          compTitle:
            contract?.type === EContractType?.QUICK_TRANSACTION
              ? READY_FOR_CASHOUT_STATUS
              : ITEM_ACCEPTED_STATUS,
          backGround:
            contract?.type === EContractType?.QUICK_TRANSACTION
              ? "rgba(240, 250, 243, 1)"
              : "rgba(99, 202, 250, 0.07)",
          compDesc:
            contract?.type === EContractType?.QUICK_TRANSACTION
              ? READY_FOR_CASHOUT_STATUS_DESCRIPTION
              : ITEM_ACCEPTED_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.READY_FOR_CASH_OUT:
        setStates({
          compImg: "/assets/images/svg/readyForCashout_status.svg",
          compTitle: READY_FOR_CASHOUT_STATUS,
          backGround: "rgba(240, 250, 243, 1)",
          compDesc: READY_FOR_CASHOUT_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.CASH_OUT_APPROVED:
        setStates({
          compImg: "/assets/images/svg/cashOutApproved_status.svg",
          compTitle: CASHOUT_APPROVED_STATUS,
          backGround: "rgba(12, 75, 196, 0.05)",
          compDesc: CASHOUT_APPROVED_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.PARTIAL_CASHOUT:
        setStates({
          compImg: "/assets/images/svg/cashOutApproved_status.svg",
          compTitle: CASHOUT_APPROVED_STATUS,
          backGround: "rgba(12, 75, 196, 0.05)",
          compDesc: CASHOUT_APPROVED_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE:
      case ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE:
        setStates({
          compImg: "/assets/images/svg/waitingSettlement.svg",
          compTitle: WAITING_SETTLEMENT_STATUS,
          backGround: "rgba(255, 195, 84, 0.06)",
          compDesc: WAITING_SETTLEMENT_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.ITEM_INSPECTION:
        setStates({
          compImg: "/assets/images/svg/inspection.svg",
          compTitle: WAITING_FOR_INSPECTION,
          backGround: "rgba(99, 202, 250, 0.07)",
          compDesc: WAITING_FOR_INSPECTION_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.INSPECTION_ESCALATION:
        setStates({
          compImg: "/assets/images/svg/arbitration.svg",
          compTitle: ESCALATION_STATUS,
          backGround: "rgba(209, 139, 73, 0.07)",
          compDesc:
            escalationType ===
              EContractActions.ADMIN_ESCALATE_DELIVERY_FOR_CUSTOMER ||
            escalationType === EContractActions.CUSTOMER_REJECT_ITEM
              ? ESCALATION_STATUS_DESCRIPTION_CUSTOMER
              : ESCALATION_STATUS_DESCRIPTION_SELLER,
        });
        break;
      case ECONTRACT_STATUS.DELIVERY_ESCALATION:
        setStates({
          compImg: "/assets/images/svg/arbitration.svg",
          compTitle: ESCALATION_STATUS,
          backGround: "rgba(209, 139, 73, 0.07)",
          compDesc:
            escalationType ===
              EContractActions.ADMIN_ESCALATE_DELIVERY_FOR_CUSTOMER ||
            escalationType === EContractActions.CUSTOMER_DENY_DELIVERY
              ? ESCALATION_STATUS_DESCRIPTION_CUSTOMER
              : ESCALATION_STATUS_DESCRIPTION_SELLER,
        });
        break;
      case ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: RESOLVED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc: RESOLVE_BUYER_REFUND_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: RESOLVED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc: RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: CLOSED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc: CLOSED_REFUND_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: CLOSED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc: CLOSED_RELEASE_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.CANCELED:
        setStates({
          compImg: "/assets/images/svg/cancellation.svg",
          compTitle: CANCELLED_STATUS_TITLE,
          backGround: "rgba(239, 98, 98, 0.07)",
          compDesc: CANCELLED_STATUS_DESCRIPTION,
        });
        break;
      default:
        break;
    }
  };
  return (
    <div>
      <ContractSubTitle text={CONTRACT_STATUS} />
      <div
        className={styles.statusCard}
        style={{ background: backGroundColor }}>
        <div className={styles.row}>
          <ButtonBase>
            <Img alt="" src={img} />
          </ButtonBase>
          <div className={styles.text_wrapper}>
            <p className={styles.title}>{title}</p>
            <p className={styles.description}>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;
